import React, { useEffect } from 'react'
import axios from 'axios'
import Showdown from 'showdown'


const MainBlog = ({ url }) => {

    useEffect(() => {
        // URL OF THE LINK OF THE README
        const urlReadmeBlog = url.ReadmeBlog
        
        // FUNTION FOR CONVERT MARDOWN TO HTML AND INSERT IN THE MAIN BLOG
        const insertContentBlog = async () => {
            // PETITION WITH AXIOS
            const dataPetition =  await axios.get(urlReadmeBlog)
            const textPlan = dataPetition.data
            const markdownConvertHtml = new Showdown.Converter().makeHtml(textPlan)
            const containerMainBlog = document.getElementById('mainContentBlog')
            containerMainBlog.insertAdjacentHTML("beforeend", markdownConvertHtml)
        }

        // FUNCTION CALL
        insertContentBlog();
    }, [])

    return (
        <section className="contentBlogInput" id="mainContentBlog" >  </section>
    )
}

export default MainBlog;